import {createSelector} from 'reselect';

const headerSelector = (state) => (state && state.header) || {};

const forceShowDisclaimerSelector = createSelector(
  headerSelector,
  (header = {}) => header.forceShowDisclaimer || false,
);

export {forceShowDisclaimerSelector};
